import React from 'react';
import { bool, string } from 'prop-types';
import { Box, Typography } from '@mui/material';
import { ProductIndicatorBadge } from 'common';

import { useTheme } from '@mui/material/styles';
import { badgeStyles, headerStyles } from './Header.styles';

const CardHeader = ({ proprietary, title }) => {
  const theme = useTheme();
  return (
    <Box sx={headerStyles(theme)}>
      <Typography noWrap variant="h6">
        {title}
      </Typography>
      <ProductIndicatorBadge proprietary={proprietary} sx={badgeStyles} />
    </Box>
  );
};

CardHeader.propTypes = {
  proprietary: bool,
  title: string.isRequired,
};

CardHeader.defaultProps = {
  proprietary: null,
};

export default CardHeader;
